import { createFileRoute, redirect } from '@tanstack/react-router';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Admin',
    link: { to: '/admin' },
  },
  {
    label: 'Roster',
    link: { to: '/admin/roster' },
  },
];

export const Route = createFileRoute('/admin/roster')({
  component: RouteComponent,
  beforeLoad: () => {
    return redirect({
      to: '/app/admin-section/roster',
    });
  },
  ssr: false,
});

function RouteComponent() {
  return (
    <>
      <AdminPageContent>
        <AdminPageHeader breadcrumbItems={breadcrumbItems} />
      </AdminPageContent>
    </>
  );
}
